import React, { useEffect, useRef, useState } from "react";
import html2pdf from "html2pdf.js";
import { Box, Button, Typography } from "@mui/material";
import ProductAndServices from "../../../Components/BRSR/SectionA/ProductAndServices";
import Employees from "../../../Components/BRSR/SectionA/Employees";
import Transparency from "../../../Components/BRSR/SectionA/Transparency";
import Operations from "../../../Components/BRSR/SectionA/Operations";
import HoldingCompanies from "../../../Components/BRSR/SectionA/HoldingCompanies";
import Details from "../../../Components/BRSR/SectionA/Details";
import { useParams } from "react-router-dom";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import MainSidebar from "../../../Layout/MainSidebar";
import PolicyManagement from "../../../Components/BRSR/SectionB/PolicyManagement";
import Governance from "../../../Components/BRSR/SectionB/Governance";
import styles from "../../../styles/brsr/general.module.css";
import { downloadReport } from "../../../Components/Quetionary/Review/downloadReport";
import EssentialIndicator from "../../../Components/BRSR/SectionC/Principle1/EssentialIndicator";
import LeadershipIndicator from "../../../Components/BRSR/SectionC/Principle1/LeadershipIndicator";
import Principle2EssentialIndicator from "../../../Components/BRSR/SectionC/Principle2/EssentialIndicator";
import Principle2LeadershipIndicator from "../../../Components/BRSR/SectionC/Principle2/LeadershipIndicator";
import Principle3EssentialIndicator from "../../../Components/BRSR/SectionC/Principle3/EssentialIndicator";
import Principle3LeadershipIndicator from "../../../Components/BRSR/SectionC/Principle3/LeadershipIndicator";
import Principle4EssentialIndicator from "../../../Components/BRSR/SectionC/Principle4/EssentialIndicator";
import Principle4LeadershipIndicator from "../../../Components/BRSR/SectionC/Principle4/LeadershipIndicator";
import Principle5EssentialIndicator from "../../../Components/BRSR/SectionC/Principle5/EssentialIndicator";
import Principle5LeadershipIndicator from "../../../Components/BRSR/SectionC/Principle5/LeadershipIndicator";
import Principle6EssentialIndicator from "../../../Components/BRSR/SectionC/Principle6/EssentialIndicator";
import Principle6LeadershipIndicator from "../../../Components/BRSR/SectionC/Principle6/LeadershipIndicator";
import Principle7EssentialIndicator from "../../../Components/BRSR/SectionC/Principle7/EssentialIndicator";
import Principle7LeadershipIndicator from "../../../Components/BRSR/SectionC/Principle7/LeadershipIndicator";
import Principle8EssentialIndicator from "../../../Components/BRSR/SectionC/Principle8/EssentialIndicator";
import Principle8LeadershipIndicator from "../../../Components/BRSR/SectionC/Principle8/LeadershipIndicator";
import Principle9EssentialIndicator from "../../../Components/BRSR/SectionC/Principle9/EssentialIndicator";
import Principle9LeadershipIndicator from "../../../Components/BRSR/SectionC/Principle9/LeadershipIndicator";
import { useUser } from "../../../context/AuthContext";
const BrsrDownload_1 = () => {
  // const pdfRef = useRef();
  // const { user } = useUser();

  // const [isGenerating, setIsGenerating] = useState(false);
  // const [progress, setProgress] = useState(0);

  // const handleDownload = async () => {
  //   setIsGenerating(true);
  //   // setProgress(0);
  //   console.log(user?.company?.companyImage, "logo");
  //   try {
  //     await downloadReport(
  //       pdfRef,
  //       "BRSR_REPORT.pdf",
  //       "BRSR REPORT",
  //       "https://upload.wikimedia.org/wikipedia/commons/7/70/Example.png"
  //     );
  //   } catch (error) {
  //     console.error("PDF generation failed:", error);
  //     alert("Failed to generate PDF. Please check console for details.");
  //   } finally {
  //     setIsGenerating(false);
  //   }
  // };


  return (
<h1>hello this is the new download page</h1>
  );
};

export default BrsrDownload_1;
